// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';




export default function DocTypeAddDialog(props) {

  const { sysID, open, onClose, afterUpdate, editMode, docType } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);


  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");




  const handleCloseClick = () => {
    initData();

    onClose && onClose();
  }

  const initData = () => {
    setValue("desc", "")
  }

  // Setup inital form values
  const defaultFormValues = {
    desc: "",
  }

  // React Hook the form
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: defaultFormValues
  });

  // Use when "open" changed
  useEffect(() => {
    // console.log("useEffect DocTypeEditDialog(open)");
    if (open && editMode) {
      setValue("desc", docType.RefCodeDesc);

    }

  }, [open])

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });
  }

  const watchDesc = watch("desc");

  const onSubmit = data => {
    console.log("onSubmit", data);

    if (editMode) {
      setShowLoading(true);
      DmsService.editDocTypePromise(gState.sessionID, sysID, docType.RefCode, data.desc)
        .then(() => {

          setShowLoading(false);

          initData();
          afterUpdate && afterUpdate();
        })
        .catch((e) => {
          setShowLoading(false);

          // setErrMsg(e.errMsg || e.message);
          // setShowError(true);
          onCatchPromiseError(e)

        })
    } else {
      setShowLoading(true);
      DmsService.addDocTypePromise(gState.sessionID, sysID, data.desc)
        .then(() => {

          setShowLoading(false);

          initData();
          afterUpdate && afterUpdate();
        })
        .catch((e) => {
          setShowLoading(false);

          // setErrMsg(e.errMsg || e.message);
          // setShowError(true);
          onCatchPromiseError(e);

        })
    }


  }


  return (
    <Dialog
      open={open}
      maxWidth={"md"}
      aria-describedby="doctype-add-dialog-description"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <DialogTitle id="alert-dialog-title">
        {editMode && "Edit Document Type"}
        {!editMode && "Add Document Type"}
      </DialogTitle>
      <DialogContent>

        <Box sx={{ display: 'flex', flexDirection: 'column' }} component="form" onSubmit={handleSubmit(onSubmit)} >

          <Controller
            name="desc"
            control={control}
            render={({ field }) =>

              <TextField
                label="Description"

                sx={{ m: 1, width: "300px" }}
                {...field}
                InputLabelProps={{ shrink: true, }}
              />

            }
          />


          <Box sx={{ textAlign: 'right', mt: 1 }} >

            <Button onClick={handleCloseClick}>Cancel</Button>
            <Button type="submit" variant="contained" startIcon={<SaveIcon />} disabled={(!watchDesc || watchDesc.trim() == "")}  >
              Save
            </Button>
          </Box>

        </Box>
      </DialogContent>
      <DialogActions>

      </DialogActions>
    </Dialog>

  );
}

DocTypeAddDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  afterUpdate: PropTypes.func,
  editMode: PropTypes.bool,
  docType: PropTypes.object,
};
